import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { FaImages, FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";
import { Editor } from "@tinymce/tinymce-react";


function Article() {

  const [article, setArticle] = useState([]);
  const [addArticle, setAddArticle] = useState(null);
  const [addItem, setAddItem] = useState(null);
  const [editId, setEditId] = useState(null);
  const [files, setFiles] = useState([]);
  const [content,setContent] = useState("");  
  const [page,setPage] = useState(1)
  const [totalPage,setTotalPage] = useState(1)

  const [category,setCategory] = useState("")
  const [search,setSearch] = useState("")


  const truncateText = (text, maxLength = 150) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };
  
  const [formDataArticle, setFormDataArticle] = useState({ title:'', description:'', image:'', slug:'', category:'', hashtag:'', ig_link:'', tiktok_link:'', fb_link:''});
  
  const handleAdd = (event) => {
    setAddArticle(event);
    setFormDataArticle({ title:event.title, description:event.description, image:event.image, slug:event.slug, category:event.categeory, hashtag:event.hashtag , fb_link:event.fb_link , ig_link:event.ig_link  , tiktok_link:event.tiktok_link  });
  };

  const fetchArticle = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/events?page=${page}&category=${category}&search=${search}`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];
      setTotalPage(note.total_page)

      setArticle(note.data);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(()=>{
     fetchArticle()
  },[page,category,search])

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataArticle({
      title: item.title,
      description: item.description,
      slug: item.slug,
      category: item.category,
      hashtag: item.hashtag,
      fb_link: item.fb_link,
      tiktok_link: item.tiktok_link,
      ig_link: item.ig_link,
      image: null
    });

    setAddArticle(true); // buka modal
  };
  

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataArticle.title);
      formData.append("description", formDataArticle.description);
      formData.append("image", formDataArticle.image);
      formData.append("slug", formDataArticle.slug);
      formData.append("category", formDataArticle.category);
      formData.append("hashtag", formDataArticle.hashtag);
      formData.append("fb_link", formDataArticle.fb_link);
      formData.append("tiktok_link", formDataArticle.tiktok_link);
      formData.append("ig_link", formDataArticle.ig_link);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/events/create`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataArticle({
          title: "",
          description: "",
          image: "",
          slug: "",
          hashtag: "",
          category: "",
          fb_link: "",
          tiktok_link: "",
          ig_link: "",
        });

        setAddArticle(null);
        await fetchArticle();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Article berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Artikel ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/events/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Article berhasil dihapus.', 'success');
            fetchArticle();
          });
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", formDataArticle.title);
      formData.append("description", formDataArticle.description);
      formData.append("category", formDataArticle.category);
      formData.append("hashtag", formDataArticle.hashtag);
      formData.append("slug", formDataArticle.slug);
      formData.append("fb_link", formDataArticle.fb_link);
      formData.append("tiktok_link", formDataArticle.tiktok_link);
      formData.append("ig_link", formDataArticle.ig_link);

      if (formDataArticle.image) {
        formData.append("image", formDataArticle.image);
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/events/${editId}`,
        {
          method: "POST", 
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {

        await fetchArticle(); // refresh data
        
        setAddArticle(null);
        await fetchArticle();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Article berhasil diupdate!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal update");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                List Article
              </div>
              <div className='flex flex-row p-4'>
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400  text-transparent">
                    <tr>
                      <th class="p-4 font-medium text-gray-900 text-center">Title</th>
                      <th width="50%" class="p-4 font-medium text-gray-900 text-center">Content</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Image</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    {Array.isArray(article) && article.map((a, idx) => (
                      <>
                        <tr class="hover:bg-gray-500">
                          <td class="p-4 text-white text-center">
                            {a.title}
                          </td>
                          <td class="p-4 text-white text-center">
                            <div
                              className="line-clamp-3 text-white"
                              dangerouslySetInnerHTML={{ __html: a.description }}
                            />
                          </td>
                          <td class="p-4 text-white text-center">
                            <img className='max-h-80' src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.image}`} />
                          </td>
                          <td class="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaPencil onClick={() => handleEditClick(a)} className='cursor-pointer'></FaPencil> 
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
              </div>
              <div className="flex gap-2 justify-center">
                {[...Array(totalPage)].map((_,i)=>(
                  <button
                    key={i}
                    onClick={()=>setPage(i+1)}
                    className={`px-4 py-2 border ${
                    page===i+1 ? "bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold hover:shadow-lg hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300":"bg-slate-700 text-gray-300 rounded-full"
                    }`}
                  >
                    {i+1}
                  </button>
                ))}
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {addArticle && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          onClick={() => {
            setAddArticle(null);
            setEditId(null);
          }}
        >
          <div
            className="bg-white text-black p-6 rounded-2xl w-full max-w-4xl relative shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
              onClick={() => {
                setAddArticle(null);
                setEditId(null);
              }}
            >
              <X size={20} />
            </button>

            {/* Title */}
            <h3 className="text-xl font-bold mb-6 text-center">
              {editId
                ? "Edit Article"
                : "Tambah Article "}
            </h3>

            {/* Form */}
            <form
              onSubmit={editId ? handleUpdate : handleInsert}
              className="space-y-4"
            >
              <div className="flex flex-row gap-2">
                <div className="w-1/2">
                  <label className="block font-medium mb-1">Title</label>
                  <input
                    type="text"
                    name='title'
                    value={formDataArticle.title}
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        title: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    required
                  />
                </div>
                <div className="w-1/2">
                  <label className="block font-medium mb-1">Category</label>
                  <select
                    name='category'
                    value={formDataArticle.category}
                    className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        category: e.target.value,
                      })
                    }
                    >
                    <option value="">-- Pilih Kategori --</option>
                    <option value="1">Article</option>
                    <option value="2">Blog</option>
                    <option value="3">News</option>
                    <option value="4">Event</option>
                  </select> 
                </div>
              </div>

              <div>
                <label className="block font-medium mb-1">Description</label>
                  <Editor
                    apiKey="yirc6bmd2u5l4k3l6i8cfwbxtd4mayfighshhkt290tsunat"
                    init={{
                    height:500,
                    plugins:[
                    'image',
                    'link',
                    'lists',
                    'code'
                    ],
                    toolbar:
                    'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | image | code',

                    images_upload_url: "https://backend.radarpulsa.com/public/api/events/uploadImage",

                    automatic_uploads:true,
                    file_picker_types:'image'
                    }}
                    value={formDataArticle.description}
                    onEditorChange={(value)=>
                      setFormDataArticle({
                        ...formDataArticle,
                        description:value
                      })
                    }
                  />
                
              </div>

              <div className='flex flex-row gap-2'>
                <div className='w-1/2'>
                  <label className="block font-medium mb-1">Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        image: e.target.files[0],
                      })
                    }
                    className="w-full border border-gray-300 p-2 rounded-lg"
                  />
                  <span className='text-sm text-red-600'><i>*rekomendasi file type: .png, .jpg, .jpeg</i></span>
                </div>
                <div className='w-1/2'>
                  <label className="block font-medium mb-1">Hashtag</label>
                  <input
                    type="text"
                    name='hashtag'
                    placeholder="#radarpulsa #radarpulsaofficial"
                    value={formDataArticle.hashtag}                    
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        hashtag: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    required
                  />
                </div>

              </div>

              <div className='flex flex-row gap-2'>
                <div className='w-1/3'>
                  <label className="block font-medium mb-1">Link IG</label>
                  <input
                    type="text"
                    name='ig_link'
                    placeholder="https://www.instagram.com/p/DVSwLiqAAkl/?igsh=MWtpc2s5dXMxMmxyNw=="
                    value={formDataArticle.ig_link}                    
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        ig_link: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    
                  />
                </div>
                <div className='w-1/3'>
                  <label className="block font-medium mb-1">Link FB</label>
                  <input
                    type="text"
                    name='fb_link'
                    value={formDataArticle.fb_link}                    
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        fb_link: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    
                  />
                </div>
                <div className='w-1/3'>
                  <label className="block font-medium mb-1">Link Tiktok</label>
                  <input
                    type="text"
                    name='tiktok_link'
                    value={formDataArticle.tiktok_link}                    
                    onChange={(e) =>
                      setFormDataArticle({
                        ...formDataArticle,
                        tiktok_link: e.target.value,
                      })
                    }
                    className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    
                  />
                </div>

              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                  onClick={() => {
                    setAddArticle(null);
                    setEditId(null);
                  }}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  {editId ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
          
        </div>
      )}
    </div>
  );
}

export default Article;
 